import React, { useEffect, useState } from 'react';
import './ListaProductos.css';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const ListaProductos = ({ refresh }) => {
  const [productos, setProductos] = useState([]);
  const [open, setOpen] = useState(false);
  const [productoToEdit, setProductoToEdit] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  // Cargar productos
  useEffect(() => {
    const fetchProductos = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/productos`);
        const data = await response.json();
        setProductos(data);
      } catch (error) {
        console.error("Error al obtener los productos:", error);
      }
    };

    fetchProductos();
  }, [refresh]);

  // Abrir y cerrar modal de edición
  const handleClickOpen = (producto) => {
    setProductoToEdit(producto);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setProductoToEdit(null);
  };

  // Manejar cambios en campos de texto
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductoToEdit({
      ...productoToEdit,
      [name]: value,
    });
  };

  // Guardar cambios en producto
  const saveChanges = async () => {
    if (productoToEdit) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/productos/${productoToEdit.id_producto}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(productoToEdit),
        });
        if (response.ok) {
          setProductos(prev =>
            prev.map(p =>
              p.id_producto === productoToEdit.id_producto ? { ...p, ...productoToEdit } : p
            )
          );
          handleClose();
        }
      } catch (error) {
        console.error("Error al guardar los cambios:", error);
      }
    }
  };

  // Eliminar producto
  const eliminarProducto = async (id_producto) => {
    const confirmacion = window.confirm("¿Seguro que deseas eliminar este producto?");
    if (!confirmacion) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/productos/${id_producto}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        setProductos(prev => prev.filter(p => p.id_producto !== id_producto));
      } else {
        alert("Error al eliminar el producto.");
      }
    } catch (error) {
      console.error("Error al eliminar producto:", error);
      alert("No se pudo eliminar el producto.");
    }
  };

  // Filtrar y ordenar productos
  const productosFiltrados = productos.filter(p =>
    p.nombre_producto.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const ordenarPor = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const productosOrdenados = [...productosFiltrados].sort((a, b) => {
    if (!sortConfig.key) return 0;
    let valA = a[sortConfig.key];
    let valB = b[sortConfig.key];
    if (typeof valA === 'string') valA = valA.toLowerCase();
    if (typeof valB === 'string') valB = valB.toLowerCase();
    if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
    if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  return (
    <div className="tabla-productos-container">
      <TextField
        label="Buscar producto"
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <p><strong>Total de productos:</strong> {productosFiltrados.length}</p>

      <table id="tabla-productos">
        <thead>
          <tr>
            <th onClick={() => ordenarPor('nombre_producto')} style={{ cursor: 'pointer' }}>Nombre</th>
            <th onClick={() => ordenarPor('cantidad')} style={{ cursor: 'pointer' }}>Cantidad</th>
            <th onClick={() => ordenarPor('precio_producto')} style={{ cursor: 'pointer' }}>Precio (€)</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {productosOrdenados.map(producto => (
            <tr key={producto.id_producto} className="producto-row">
              <td onDoubleClick={() => handleClickOpen(producto)}>{producto.nombre_producto}</td>
              <td onDoubleClick={() => handleClickOpen(producto)}>{producto.cantidad}</td>
              <td onDoubleClick={() => handleClickOpen(producto)}>€{producto.precio_producto}</td>
              <td style={{ textAlign: 'center' }}>
                <IconButton color="error" onClick={() => eliminarProducto(producto.id_producto)}>
                  <DeleteIcon />
                </IconButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Editar Producto</DialogTitle>
        <DialogContent>
          {productoToEdit && (
            <div>
              <TextField
                label="Nombre"
                variant="outlined"
                fullWidth
                margin="normal"
                name="nombre_producto"
                value={productoToEdit.nombre_producto}
                onChange={handleChange}
              />
              <TextField
                label="Cantidad"
                variant="outlined"
                fullWidth
                margin="normal"
                name="cantidad"
                value={productoToEdit.cantidad}
                onChange={handleChange}
                type="number"
              />
              <TextField
                label="Precio (€)"
                variant="outlined"
                fullWidth
                margin="normal"
                name="precio_producto"
                value={productoToEdit.precio_producto}
                onChange={handleChange}
                type="number"
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Cancelar</Button>
          <Button onClick={saveChanges} color="primary">Guardar Cambios</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ListaProductos;
